import client from "../config/axiosConfig";

export const getMyConsultationsApi = () =>
  client.get("/consultation/member/open");
export const getConsultationApi = (consultationId) =>
  client.get(`/consultation/${consultationId}`);
export const createConsultationApi = (payload) =>
  client.post(`/consultation`, payload);
